var _path, _line, _circle, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInterest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6878 10.0553C18.8998 9.7816 15.4502 9.13997 12.9904 10.5011C12.5969 10.7189 12.105 10.7312 11.7453 10.4614L10.5662 9.57707C9.72201 8.94394 8.59986 9.88047 9.07177 10.8243L9.44935 11.5794C9.63897 11.9587 9.55087 12.4054 9.32125 12.7618C8.98463 13.2844 8.94139 13.7447 8.92985 14.2981C8.91888 14.824 8.49419 15.2321 7.96819 15.2321L6.88309 15.2321C6.3308 15.2321 5.88308 15.6799 5.88309 16.2321L5.8831 17.6834C5.88311 18.2357 6.33082 18.6834 6.8831 18.6834L8.00269 18.6834C8.51431 18.6834 8.92263 19.0753 9.04479 19.5721C9.23617 20.3504 9.5905 20.6926 10.3879 21.0237C10.7833 21.1879 11.0595 21.5597 11.0595 21.9878L11.0595 24.5859C11.0595 25.1382 11.5072 25.5859 12.0595 25.5859L13.0793 25.5859C13.6316 25.5859 14.0793 25.1382 14.0793 24.5859L14.0793 23.9975C14.0793 23.4452 14.527 22.9975 15.0793 22.9975L17.8248 22.9975C18.3771 22.9975 18.8248 23.4452 18.8248 23.9975L18.8248 24.5859C18.8248 25.1382 19.2725 25.5859 19.8248 25.5859L20.8446 25.5859C21.3969 25.5859 21.8446 25.1382 21.8446 24.5859L21.8446 22.6313C21.8446 22.3184 21.9939 22.0246 22.2359 21.8264C26.6877 18.1792 25.2132 14.2983 22.276 11.7809",
    stroke: "#0BC196",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 22.5,
    y1: 7.93934,
    x2: 26.4393,
    y2: 4,
    stroke: "#24D1A8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 4,
    r: 0.5,
    fill: "#0EF1BC",
    stroke: "#0EF1BC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 8,
    r: 0.5,
    fill: "#0EF1BC",
    stroke: "#0EF1BC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterest);
export default __webpack_public_path__ + "static/media/interest.5b27b969c97929a4c9cca12d43a60479.svg";
export { ForwardRef as ReactComponent };